import { render, staticRenderFns } from "./joker.vue?vue&type=template&id=ca67a104"
import script from "./joker.vue?vue&type=script&lang=js"
export * from "./joker.vue?vue&type=script&lang=js"
import style0 from "./joker.vue?vue&type=style&index=0&id=ca67a104&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports